/**
 * ILLUSTRATIVE reporting data for the Caprelsa Snak concept.
 * Fictional values and verbatims for demonstration only — NOT campaign results and NOT real HCP statements.
 */

export const insightPeriod = 'Illustrative 6-week pilot · 2 EU markets'

export const kpis = [
  { value: '438', label: 'Snak starts', detail: 'from 2,400 HCPs reached' },
  { value: '55%', label: 'Completion', detail: '241 reached the final scene' },
  { value: '2m 14s', label: 'Avg. time in Snak', detail: 'median 1m 52s' },
  { value: '96', label: 'Open-text answers', detail: '40% of completers' },
  { value: '19%', label: 'CTA click-through', detail: 'to evidence, safety or SmPC' },
]

export const sceneFunnel = [
  { scene: 'Attract', reached: 438, dwell: 9 },
  { scene: 'Interact', reached: 391, dwell: 31 },
  { scene: 'Reveal · PFS', reached: 318, dwell: 42 },
  { scene: 'Explain · MoA', reached: 270, dwell: 24 },
  { scene: 'Continue', reached: 241, dwell: 18 },
]

export const firstConsideration = [
  { label: 'RET mutation status', share: 41 },
  { label: 'Progression & symptoms', share: 38 },
  { label: 'Benefit–risk & safety', share: 21 },
]

export const exploredAllThree = 46

export const nextStepChosen = [
  { label: 'Explore the evidence', share: 44 },
  { label: 'Review safety information', share: 27 },
  { label: 'Understand the mechanism', share: 18 },
  { label: 'EU prescribing information', share: 11 },
]

export const segments = [
  {
    name: 'Oncologists',
    n: 264,
    metrics: [
      { label: 'Opened RET status first', value: 34 },
      { label: 'Opened safety', value: 58 },
      { label: 'Completed', value: 59 },
    ],
  },
  {
    name: 'Endocrinologists',
    n: 174,
    metrics: [
      { label: 'Opened RET status first', value: 52 },
      { label: 'Opened safety', value: 71 },
      { label: 'Completed', value: 49 },
    ],
  },
]

export const channels = [
  { label: 'HCP email', starts: 46, completion: 51 },
  { label: 'Rep-guided iPad', starts: 24, completion: 78 },
  { label: 'Congress QR', starts: 18, completion: 44 },
  { label: 'Digital banner', starts: 12, completion: 31 },
]

export const openQuestion = 'What would most help your next treatment decision in advanced MTC?'

export const themes = [
  {
    theme: 'RET testing access & turnaround',
    share: 31,
    quotes: [
      { text: 'Getting a validated RET result quickly is still the bottleneck in our centre.', role: 'Endocrinologist · DE' },
      { text: 'Tissue from diagnosis is often years old — retesting logistics matter.', role: 'Medical oncologist · ES' },
    ],
  },
  {
    theme: 'QTc monitoring logistics',
    share: 24,
    quotes: [{ text: 'A simple ECG monitoring schedule I can hand to the cardiology team would help.', role: 'Medical oncologist · ES' }],
  },
  {
    theme: 'Sequencing after selective RET inhibitors',
    share: 19,
    quotes: [{ text: 'I want clearer data on what to use after progression on a selective RET inhibitor.', role: 'Medical oncologist · DE' }],
  },
  {
    theme: 'Managing symptom burden',
    share: 15,
    quotes: [{ text: 'Diarrhoea and flushing drive my patients’ quality of life more than scans.', role: 'Endocrinologist · ES' }],
  },
  {
    theme: 'Paediatric & hereditary MTC',
    share: 11,
    quotes: [{ text: 'Practical dosing guidance for adolescents with MEN2 would be valuable.', role: 'Paediatric endocrinologist · DE' }],
  },
]

export const signals = [
  {
    signal: 'RET status is the first question for endocrinologists',
    evidence: '52% opened RET first vs 34% of oncologists · top open-text theme (31%)',
    implication: 'A testing-pathway Snak for endocrinology could remove a real barrier before treatment decisions.',
  },
  {
    signal: 'The evidence scene earns the longest attention',
    evidence: '42s average dwell on PFS · 44% chose “Explore the evidence” next',
    implication: 'Lead follow-up email and rep conversations with the ZETA data deep-dive.',
  },
  {
    signal: 'Safety is a gate, not an afterthought',
    evidence: '71% of endocrinologists opened safety · 24% of verbatims on QTc logistics',
    implication: 'Offer a practical ECG-monitoring resource alongside the efficacy story.',
  },
  {
    signal: 'Rep-guided play converts best',
    evidence: '78% completion on rep iPad vs 51% via email',
    implication: 'Use email to identify engaged HCPs, then route them to a rep or MSL conversation.',
  },
]
